import * as React from 'react'

const RainIcon = props => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.4729 4.66223H6.09829C5.68512 4.66223 5.3514 4.29397 5.39908 3.87767C5.39908 3.86967 5.39908 3.86166 5.39908 3.86166C5.51031 2.95701 6.24131 2.2445 7.13915 2.15644C7.41725 2.12441 7.6874 2.15644 7.93371 2.23649C7.94165 2.22048 7.94165 2.21248 7.9496 2.19646C8.34688 1.2678 9.26061 0.611328 10.3333 0.611328C10.5796 0.611328 10.81 0.643351 11.0325 0.707397C11.8668 0.939563 12.5342 1.59603 12.7964 2.42063C13.0506 2.31655 13.3367 2.27652 13.6307 2.30855C14.4252 2.39661 15.0688 3.03707 15.1642 3.83764C15.1642 3.86166 15.1721 3.89368 15.1721 3.9177C15.1959 4.32599 14.8702 4.66223 14.4729 4.66223Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2399 1.85222C11.0333 2.20447 10.5883 2.33256 10.2467 2.55672C9.76995 2.86895 9.42035 3.42134 8.85621 3.50941C8.70525 3.53342 8.53839 3.51741 8.40332 3.43736C8.24441 3.34929 8.14111 3.18117 8.07755 3.01305C8.00604 2.82892 7.96631 2.62878 7.95042 2.42863C7.94247 2.28453 7.97426 2.13242 8.03782 2.00433C8.47483 1.17173 9.33294 0.611328 10.3261 0.611328C10.3897 0.611328 10.4533 0.611327 10.5248 0.619333C10.9856 0.651356 11.367 1.03563 11.3352 1.50797C11.3352 1.62806 11.3034 1.74814 11.2399 1.85222Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2453 1.06055C10.1976 1.06055 10.1499 1.06055 10.1102 1.06055C9.95129 1.06855 9.78443 1.10058 9.64141 1.16462C9.54606 1.21266 9.45072 1.2687 9.36332 1.33274C9.23619 1.43682 9.10906 1.58092 9.15673 1.74904C9.18057 1.8371 9.25208 1.90916 9.33948 1.93317C9.47455 1.9652 9.57785 1.88514 9.67319 1.81309C9.79238 1.71702 9.91156 1.62095 10.0466 1.54089C10.1102 1.50887 10.1738 1.47685 10.2373 1.45283C10.3009 1.42881 10.3724 1.44482 10.4201 1.39679C10.4519 1.36476 10.4598 1.32474 10.4598 1.28471C10.4598 1.22066 10.4439 1.15662 10.4042 1.10858C10.3724 1.07656 10.3247 1.06855 10.2771 1.06855C10.2612 1.06055 10.2532 1.06055 10.2453 1.06055Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.87936 1.94141C8.9032 1.94141 8.93498 1.94941 8.95882 1.96542C9.01443 2.00545 9.07005 2.09352 9.07005 2.16557C9.078 2.26164 9.01443 2.36571 8.91909 2.40574C8.87936 2.42175 8.82374 2.42976 8.77607 2.42175C8.73634 2.41375 8.69661 2.39773 8.67278 2.36571C8.60127 2.28565 8.63305 2.14155 8.68072 2.06149C8.72839 1.99745 8.80785 1.94141 8.87936 1.94141Z"
      fill="white"
    />
    <path
      opacity="0.3"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.4881 2.60479C7.36892 2.58878 7.2259 2.6128 7.11466 2.63682C6.99548 2.66083 6.87629 2.70086 6.76506 2.76491C6.67766 2.81294 6.5982 2.893 6.55847 2.99707C6.52669 3.08514 6.50285 3.22924 6.60615 3.27728C6.64587 3.30129 6.69355 3.30129 6.73327 3.29329C6.83657 3.27728 6.92397 3.22124 7.01137 3.1652C7.13055 3.09314 7.24179 3.0291 7.37686 3.02109C7.44043 3.01309 7.50399 3.02109 7.56756 3.00508C7.6629 2.98106 7.71852 2.87699 7.69469 2.78092C7.67879 2.66884 7.58345 2.62081 7.4881 2.60479Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1141 5.67935C13.122 5.98357 13.0267 6.27978 12.8678 6.53597C12.6135 6.92825 12.1685 7.20044 11.6362 7.20044H1.87112C1.29109 7.20044 0.750793 6.8562 0.528318 6.31981C0.440916 6.11967 0.393243 5.90351 0.369406 5.67935C0.353515 5.54325 0.353516 5.39915 0.353516 5.26305C0.401189 4.11823 1.13218 2.97341 2.23661 3.12552C2.23661 3.12552 2.23661 3.12552 2.24456 3.12552C2.22867 2.9574 2.23661 2.79728 2.2525 2.64518C2.51471 0.499636 5.80416 -0.765272 7.25025 1.62845C7.36944 1.82058 7.47273 2.03674 7.56013 2.27691C9.02211 0.859894 11.5726 2.32495 11.088 4.26234C10.7701 5.55927 10.7701 5.55927 11.088 4.26234C11.9381 4.14225 12.5261 4.43046 12.8439 4.87077C13.0267 5.11895 13.1141 5.39915 13.1141 5.67935Z"
      fill="#EDEDED"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.32934 2.86072C7.31345 3.1169 7.24194 3.41312 7.01152 3.5252C6.81288 3.62127 6.57451 3.5332 6.38382 3.41312C6.20107 3.29303 6.03422 3.13292 5.81969 3.06887C5.39857 2.94078 4.96951 3.22098 4.65169 3.5252C4.33387 3.82941 4.0081 4.18167 3.57109 4.24571C3.18176 4.30175 2.78449 4.0936 2.53817 3.78138C2.38721 3.58924 2.29186 3.36508 2.2283 3.13292C2.2283 3.13292 2.2283 3.13292 2.23624 3.13292C2.01377 0.707175 5.68461 -0.942009 7.24194 1.62784C7.32934 2.02812 7.36112 2.44442 7.32934 2.86072Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.57151 4.58192C3.34109 4.79808 2.9597 4.686 2.68161 4.81409C2.30817 4.99022 2.2605 5.51859 1.96651 5.8068C1.65663 6.11902 1.12428 6.10301 0.774678 5.83882L0.766732 5.84683C0.456856 5.60666 0.321781 5.20637 0.401236 4.82209C0.591929 3.84539 1.27525 2.98878 2.22871 3.12488C2.21282 2.95676 2.22077 2.79664 2.23666 2.64453C2.80874 2.74861 3.3252 3.12488 3.57946 3.64525C3.65097 3.78935 3.69864 3.94146 3.71453 4.10158C3.73837 4.2777 3.69864 4.46184 3.57151 4.58192Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.36668 0.851467C5.30311 0.73138 5.18393 0.659328 5.04886 0.659328C4.71514 0.651322 4.38143 0.683345 4.10334 0.84346C4.01593 0.891495 3.92853 0.963546 3.89675 1.05962C3.88086 1.09964 3.88086 1.14768 3.88086 1.19571C3.88086 1.29178 3.9047 1.39586 3.96826 1.46791C4.03183 1.53996 4.12717 1.56398 4.21457 1.56398C4.30197 1.55597 4.38938 1.52395 4.46883 1.46791C4.52445 1.42788 4.57212 1.37984 4.63569 1.33982C4.73898 1.26776 4.85816 1.21973 4.97735 1.19571C5.07269 1.1797 5.18393 1.1717 5.27133 1.11566C5.35873 1.05961 5.4223 0.93953 5.36668 0.851467Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.48372 1.60547C3.4281 1.60547 3.36454 1.62148 3.32481 1.66151C3.22946 1.74157 3.15795 1.83764 3.11028 1.94972C3.0785 2.01376 3.06261 2.09382 3.0785 2.15786C3.08645 2.22992 3.12617 2.30197 3.18974 2.33399C3.23741 2.35801 3.30098 2.35801 3.35659 2.35C3.53934 2.31798 3.69825 2.18188 3.76182 2.01376C3.78565 1.94171 3.80154 1.86966 3.77771 1.79761C3.75387 1.69353 3.65853 1.62949 3.55523 1.62148L3.48372 1.60547Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.86366 3.50215C1.60145 3.54218 1.35514 3.67828 1.18828 3.89443C1.04526 4.07857 0.949917 4.30273 0.910189 4.53489C0.902243 4.60695 0.902243 4.687 0.949917 4.73504C0.981699 4.75906 1.02937 4.76706 1.0691 4.76706C1.13266 4.77507 1.21212 4.77507 1.26774 4.74304C1.36309 4.69501 1.41076 4.57492 1.45049 4.47085C1.52994 4.25469 1.66502 4.03854 1.88749 3.96649C1.90338 3.96649 1.91133 3.95848 1.92722 3.95848C2.00668 3.93446 2.07024 3.88643 2.10997 3.81438C2.20531 3.63025 2.02257 3.47013 1.86366 3.50215Z"
      fill="white"
    />
    <path
      opacity="0.9"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.87785 2.41378C7.82223 2.46181 7.76661 2.50984 7.73483 2.57389C7.70305 2.62993 7.6951 2.70198 7.71894 2.76603C7.77456 2.91814 7.94936 2.92614 8.07649 2.8621C8.17978 2.80606 8.25923 2.71799 8.34664 2.64594C8.4976 2.53386 8.6724 2.46981 8.85515 2.42178C8.91077 2.40577 8.97433 2.38976 9.02201 2.34973C9.06968 2.3097 9.09352 2.24565 9.06968 2.18961C9.04585 2.13357 8.97434 2.10956 8.91077 2.10155C8.70419 2.07753 8.4976 2.10956 8.30691 2.18961L8.21156 2.22964C8.08443 2.27768 7.9732 2.34172 7.87785 2.41378Z"
      fill="white"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1993 4.85487C11.3423 4.84686 11.4774 4.84686 11.6125 4.86287C11.8508 4.88689 12.0971 4.98296 12.2481 5.16709C12.6692 5.66345 12.3434 6.39998 11.7714 6.5761C11.533 6.64816 11.2787 6.64815 11.0245 6.64015C10.6987 6.62414 10.3491 6.58411 10.071 6.39998C9.69758 6.1518 9.57045 5.57538 9.91211 5.24715C10.0472 5.11906 10.2299 5.05501 10.4047 4.99897C10.6669 4.92692 10.9291 4.87088 11.1993 4.85487Z"
      fill="#CBBEBB"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.58497 5.63137C8.45784 5.69541 8.33866 5.78348 8.2751 5.87154C8.21948 5.9516 8.23537 6.04767 8.26715 6.13573C8.29099 6.19977 8.32277 6.26382 8.37044 6.31186C8.52141 6.44795 8.85512 6.44795 9.01403 6.34388C9.14911 6.25581 9.26035 6.04766 9.23651 5.87954C9.22062 5.76746 9.12527 5.64738 9.02992 5.59134C8.91074 5.52729 8.74388 5.55131 8.58497 5.63137Z"
      fill="#CBBEBB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.28466 9.55524C3.26082 9.61128 3.22904 9.65932 3.19726 9.70735C2.87944 10.2117 2.42654 10.3078 2.02926 10.1156C1.77501 9.98755 1.60021 9.75539 1.56842 9.45917C1.54459 9.25903 1.59226 9.02686 1.71939 8.77068C1.91008 8.3784 2.37092 8.18626 2.70464 8.09019C2.91917 8.02615 3.14164 8.13823 3.22904 8.35438C3.35617 8.67461 3.47535 9.17097 3.28466 9.55524Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.04754 9.64941C3.13494 9.66542 3.16673 9.76949 3.11111 9.84155C2.80123 10.2338 2.38806 10.3059 2.03051 10.1217C1.80009 10.0097 1.64118 9.81753 1.58556 9.56935C1.56967 9.5053 1.6094 9.44926 1.66502 9.43325C1.93517 9.36921 2.1338 9.64941 2.38806 9.73747C2.64232 9.80952 2.81712 9.60938 3.04754 9.64941Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.30032 8.49805C2.26854 8.49805 2.23676 8.50605 2.20498 8.52206C2.10168 8.5701 1.99839 8.68218 1.97455 8.79426C1.94277 8.92235 2.04606 9.06645 2.17319 8.97839C2.27649 8.90634 2.44334 8.77024 2.4354 8.62614C2.4354 8.53807 2.37183 8.49805 2.30032 8.49805Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.01459 9.70593C1.9987 9.6739 1.97486 9.64188 1.95103 9.61786C1.94308 9.61786 1.94308 9.60986 1.93514 9.60986C1.89541 9.58584 1.84773 9.57784 1.81595 9.61786C1.78417 9.65789 1.78417 9.71393 1.80801 9.75396C1.8239 9.77798 1.84773 9.802 1.87952 9.82601C1.88746 9.83402 1.89541 9.83402 1.90335 9.84202C1.9113 9.85003 1.92719 9.85003 1.93514 9.84202C1.96692 9.84202 2.00665 9.82601 2.02254 9.802C2.03843 9.77798 2.03048 9.75396 2.02254 9.72994C2.01459 9.71393 2.01459 9.71393 2.01459 9.70593Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.18916 9.77895C2.213 9.77094 2.24478 9.77895 2.27656 9.77895C2.29245 9.77895 2.30834 9.78695 2.32423 9.79496C2.34013 9.81097 2.34807 9.82698 2.34807 9.851C2.34807 9.88302 2.33218 9.89903 2.30834 9.89903C2.26861 9.90704 2.213 9.92305 2.18121 9.89103C2.14149 9.86701 2.14149 9.79496 2.18916 9.77895Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.57557 9.85935C6.55968 9.89938 6.53585 9.93941 6.51201 9.97143C6.28159 10.3397 5.94787 10.4117 5.66183 10.2676C5.47114 10.1716 5.34401 10.0035 5.32812 9.7873C5.31223 9.64319 5.34401 9.46707 5.43936 9.28293C5.58238 9.00273 5.91609 8.85063 6.1624 8.78658C6.32131 8.73854 6.48023 8.82661 6.54379 8.97872C6.62325 9.21889 6.71859 9.57915 6.57557 9.85935Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.40019 9.93114C6.46376 9.93915 6.48759 10.0192 6.44787 10.0672C6.22539 10.3555 5.92346 10.4035 5.66126 10.2754C5.4944 10.1873 5.37522 10.0512 5.33549 9.8671C5.32754 9.82707 5.35138 9.77904 5.39905 9.77103C5.59769 9.723 5.74071 9.92314 5.92346 9.99519C6.09826 10.0512 6.22539 9.89912 6.40019 9.93114Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.85201 9.08984C5.82818 9.08984 5.80434 9.09785 5.7805 9.10586C5.70899 9.14588 5.62954 9.21794 5.61365 9.306C5.58981 9.39406 5.66926 9.50614 5.76461 9.4421C5.83612 9.38606 5.96325 9.28999 5.9553 9.18591C5.9553 9.11386 5.90763 9.08984 5.85201 9.08984Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.70984 10.0106C5.69394 9.97859 5.67011 9.94657 5.64627 9.92255C5.63833 9.92255 5.63833 9.91455 5.63038 9.91455C5.59065 9.89053 5.54298 9.88252 5.5112 9.92255C5.47941 9.96258 5.48736 10.0186 5.5112 10.0587C5.52709 10.0907 5.55093 10.1067 5.58271 10.1307C5.59065 10.1387 5.5986 10.1387 5.60654 10.1467C5.61449 10.1467 5.63038 10.1467 5.63833 10.1467C5.67011 10.1467 5.70984 10.1307 5.72573 10.1067C5.74162 10.0827 5.73367 10.0586 5.72573 10.0346C5.70984 10.0186 5.70984 10.0106 5.70984 10.0106Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3647 9.55524C10.3409 9.61128 10.3091 9.65932 10.2773 9.70735C9.95952 10.2117 9.50662 10.3078 9.10934 10.1156C8.85508 9.98755 8.68028 9.75539 8.6485 9.45917C8.62466 9.25903 8.67234 9.02686 8.79947 8.77068C8.99016 8.3784 9.451 8.18626 9.78471 8.09019C9.99924 8.02615 10.2217 8.13823 10.3091 8.35438C10.4283 8.67461 10.5554 9.17097 10.3647 9.55524Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1276 9.64941C10.215 9.66542 10.2468 9.76949 10.1912 9.84155C9.88131 10.2338 9.46814 10.3059 9.11059 10.1217C8.88017 10.0097 8.72126 9.81753 8.66564 9.56935C8.64975 9.5053 8.68948 9.44926 8.7451 9.43325C9.01524 9.36921 9.21388 9.64941 9.46814 9.73747C9.71445 9.80952 9.88925 9.60938 10.1276 9.64941Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.3804 8.49805C9.34862 8.49805 9.31684 8.50605 9.28506 8.52206C9.18176 8.5701 9.07847 8.68218 9.05463 8.79426C9.02285 8.92235 9.12614 9.06645 9.25327 8.97839C9.35656 8.90634 9.52342 8.77024 9.51548 8.62614C9.51548 8.53807 9.45191 8.49805 9.3804 8.49805Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.08686 9.70593C9.07097 9.6739 9.04713 9.64188 9.02329 9.61786C9.01535 9.61786 9.01535 9.60986 9.0074 9.60986C8.96767 9.58584 8.92 9.57784 8.88822 9.61786C8.85644 9.65789 8.85644 9.71393 8.88027 9.75396C8.89616 9.77798 8.92 9.802 8.95178 9.82601C8.95973 9.83402 8.96767 9.83402 8.97562 9.84202C8.98356 9.85003 8.99946 9.85003 9.0074 9.84202C9.03918 9.84202 9.07891 9.82601 9.0948 9.802C9.11069 9.77798 9.10275 9.75396 9.0948 9.72994C9.0948 9.71393 9.0948 9.71393 9.08686 9.70593Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.26933 9.77895C9.29316 9.77094 9.32495 9.77895 9.35673 9.77895C9.37262 9.77895 9.38851 9.78695 9.4044 9.79496C9.42029 9.81097 9.42824 9.82698 9.42824 9.851C9.42824 9.88302 9.41235 9.89903 9.38851 9.89903C9.34878 9.90704 9.29316 9.92305 9.26138 9.89103C9.21371 9.86701 9.21371 9.79496 9.26933 9.77895Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.35799 13.1174C4.33415 13.1735 4.30237 13.2215 4.27058 13.2696C3.96865 13.7499 3.5237 13.854 3.14232 13.6618C2.896 13.5337 2.72915 13.3176 2.69737 13.0294C2.67353 12.8372 2.7212 12.6131 2.84039 12.3649C3.02313 11.9886 3.47603 11.7965 3.79385 11.7084C4.00044 11.6524 4.22291 11.7565 4.29442 11.9566C4.42155 12.2688 4.54073 12.7412 4.35799 13.1174Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.12669 13.2043C4.21409 13.2203 4.23793 13.3164 4.19025 13.3885C3.88832 13.7727 3.49105 13.8368 3.14939 13.6607C2.92691 13.5486 2.768 13.3645 2.72033 13.1243C2.70444 13.0682 2.74416 13.0042 2.79978 12.9882C3.06199 12.9241 3.25268 13.1963 3.49899 13.2764C3.72941 13.3645 3.89627 13.1723 4.12669 13.2043Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.39577 12.0918C3.36399 12.0918 3.33221 12.0998 3.30837 12.1158C3.21303 12.1638 3.10973 12.2679 3.0859 12.38C3.05412 12.5001 3.15741 12.6442 3.27659 12.5561C3.37988 12.4841 3.53879 12.356 3.53085 12.2199C3.53879 12.1318 3.46728 12.0998 3.39577 12.0918Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.12572 13.2682C3.10983 13.2362 3.09394 13.2042 3.06215 13.1882C3.05421 13.1882 3.05421 13.1802 3.04626 13.1802C3.00653 13.1562 2.96681 13.1481 2.93502 13.1882C2.90324 13.2202 2.91119 13.2762 2.93502 13.3163C2.95092 13.3403 2.97475 13.3643 2.99859 13.3803C3.00654 13.3883 3.01448 13.3883 3.02243 13.3963C3.03037 13.4043 3.04626 13.4043 3.05421 13.3963C3.08599 13.3963 3.11777 13.3803 3.13366 13.3563C3.14161 13.3323 3.14161 13.3083 3.13366 13.2842C3.12572 13.2762 3.12572 13.2682 3.12572 13.2682Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.29268 13.3336C3.31651 13.3256 3.34829 13.3336 3.38008 13.3336C3.39597 13.3336 3.41186 13.3416 3.42775 13.3496C3.44364 13.3657 3.44364 13.3817 3.45159 13.4057C3.45159 13.4297 3.4357 13.4457 3.41186 13.4537C3.37213 13.4617 3.31651 13.4777 3.28473 13.4457C3.245 13.4217 3.245 13.3496 3.29268 13.3336Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.10814 12.6765C8.08431 12.7245 8.06047 12.7726 8.02869 12.8206C7.74265 13.2769 7.32153 13.373 6.96398 13.1889C6.72562 13.0688 6.5667 12.8606 6.54287 12.5884C6.52698 12.4043 6.55876 12.1881 6.67794 11.956C6.85274 11.5957 7.27386 11.4196 7.58374 11.3315C7.78237 11.2755 7.98896 11.3796 8.06047 11.5717C8.16376 11.8759 8.28294 12.3242 8.10814 12.6765Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.88672 12.7652C7.96617 12.7812 7.99796 12.8773 7.95028 12.9413C7.67219 13.3016 7.2908 13.3656 6.96503 13.1975C6.75845 13.0934 6.60748 12.9173 6.55981 12.6851C6.55186 12.6291 6.58365 12.5731 6.63132 12.557C6.87763 12.493 7.06038 12.7492 7.2908 12.8292C7.51328 12.9093 7.67219 12.7252 7.88672 12.7652Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.2021 11.707C7.17032 11.707 7.14648 11.715 7.1147 11.731C7.01935 11.7791 6.93195 11.8752 6.90017 11.9792C6.87633 12.0913 6.97168 12.2274 7.08292 12.1473C7.17827 12.0833 7.32923 11.9552 7.32923 11.8271C7.32923 11.7471 7.26567 11.707 7.2021 11.707Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.94017 12.821C6.92428 12.7889 6.90839 12.7569 6.87661 12.7409C6.86866 12.7409 6.86866 12.7329 6.86072 12.7329C6.82893 12.7089 6.78126 12.7009 6.74948 12.7409C6.7177 12.7729 6.72564 12.829 6.74948 12.861C6.76537 12.885 6.78921 12.909 6.81304 12.925C6.82099 12.933 6.82893 12.933 6.83688 12.933C6.84482 12.933 6.86072 12.9411 6.86866 12.933C6.90044 12.933 6.93223 12.925 6.94812 12.893C6.95606 12.869 6.95606 12.845 6.94812 12.829C6.94812 12.821 6.94017 12.821 6.94017 12.821Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.1072 12.8844C7.13103 12.8764 7.16281 12.8844 7.18665 12.8844C7.20254 12.8844 7.21843 12.8924 7.22638 12.9004C7.24227 12.9084 7.24227 12.9325 7.24227 12.9485C7.24227 12.9725 7.23432 12.9885 7.21049 12.9965C7.17871 13.0045 7.12309 13.0205 7.0913 12.9885C7.05952 12.9645 7.05158 12.9004 7.1072 12.8844Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.70838 15.8535C5.69249 15.8935 5.66866 15.9335 5.64482 15.9656C5.4144 16.3338 5.08069 16.4059 4.79465 16.2618C4.60395 16.1657 4.47682 15.9976 4.46093 15.7814C4.44504 15.6373 4.47682 15.4612 4.57217 15.2771C4.71519 14.9969 5.0489 14.8528 5.29522 14.7807C5.45413 14.7327 5.61304 14.8207 5.6766 14.9729C5.75606 15.213 5.84346 15.5733 5.70838 15.8535Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.53301 15.9194C5.59657 15.9274 5.62041 16.0075 5.58068 16.0555C5.3582 16.3437 5.05627 16.3918 4.79407 16.2637C4.62721 16.1836 4.50803 16.0395 4.4683 15.8554C4.46036 15.8154 4.48419 15.7673 4.53187 15.7593C4.7305 15.7113 4.87353 15.9114 5.05627 15.9835C5.23107 16.0395 5.3582 15.8954 5.53301 15.9194Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.98678 15.0859C4.96294 15.0859 4.9391 15.0939 4.91527 15.1019C4.84376 15.142 4.7643 15.214 4.74841 15.3021C4.72457 15.3902 4.80403 15.5022 4.89938 15.4382C4.97089 15.3821 5.09801 15.2861 5.09007 15.182C5.09007 15.11 5.0424 15.0859 4.98678 15.0859Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.84272 15.9989C4.82683 15.9669 4.80299 15.9349 4.77915 15.9108C4.77121 15.9108 4.77121 15.9028 4.76326 15.9028C4.72353 15.8788 4.67586 15.8708 4.64408 15.9108C4.6123 15.9509 4.61229 16.0069 4.63613 16.0469C4.65202 16.079 4.67586 16.095 4.70764 16.119C4.71559 16.127 4.72353 16.127 4.73148 16.135C4.73942 16.143 4.75532 16.143 4.76326 16.135C4.79504 16.135 4.83477 16.119 4.85066 16.095C4.86655 16.0709 4.85861 16.0469 4.85066 16.0149C4.84272 16.0069 4.84272 16.0069 4.84272 15.9989Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.72792 15.8535C1.71203 15.8935 1.68819 15.9335 1.66435 15.9656C1.43393 16.3338 1.10022 16.4059 0.814179 16.2618C0.623485 16.1657 0.496356 15.9976 0.480465 15.7814C0.464573 15.6373 0.496356 15.4612 0.591703 15.2771C0.734723 14.9969 1.06844 14.8528 1.31475 14.7807C1.47366 14.7327 1.63257 14.8207 1.69613 14.9729C1.77559 15.213 1.87094 15.5733 1.72792 15.8535Z"
      fill="#75BEEA"
    />
    <path
      opacity="0.2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.55254 15.9194C1.6161 15.9274 1.63994 16.0075 1.60021 16.0555C1.37774 16.3437 1.07581 16.3918 0.813602 16.2637C0.646745 16.1836 0.527562 16.0395 0.487834 15.8554C0.479888 15.8154 0.503725 15.7673 0.551398 15.7593C0.750037 15.7113 0.893056 15.9114 1.0758 15.9835C1.25061 16.0395 1.37774 15.8954 1.55254 15.9194Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.00436 15.0859C0.980519 15.0859 0.956683 15.0939 0.932847 15.1019C0.861337 15.142 0.781881 15.214 0.76599 15.3021C0.742153 15.3902 0.821608 15.5022 0.916955 15.4382C0.988464 15.3821 1.11559 15.2861 1.10765 15.182C1.10765 15.11 1.05997 15.0859 1.00436 15.0859Z"
      fill="white"
    />
    <path
      opacity="0.5"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.862179 15.9989C0.846288 15.9669 0.822451 15.9349 0.798615 15.9108C0.790669 15.9108 0.790669 15.9028 0.782724 15.9028C0.742996 15.8788 0.695323 15.8708 0.663541 15.9108C0.631758 15.9509 0.639704 16.0069 0.663541 16.0469C0.679432 16.079 0.703269 16.095 0.735051 16.119C0.742997 16.127 0.750941 16.127 0.758887 16.135C0.766832 16.143 0.782724 16.143 0.79067 16.135C0.822452 16.135 0.862179 16.119 0.87807 16.095C0.893961 16.0709 0.886016 16.0469 0.87807 16.0149C0.862179 16.0069 0.862179 16.0069 0.862179 15.9989Z"
      fill="white"
    />
  </svg>
)

export default RainIcon
